import React from 'react';
import styled from 'styled-components';
import { Button } from '../../../button';
import { Modal } from '../../../layout/modal';
import { ModalContent, ModalTitle } from '../../../layout/modal/content';
import { MOCK_ORDER_STATUS_DATA } from '../../sidebars/changeOrderStatus';
const getOrderItemBg = (type) => {
    switch (type) {
        case 'Unconfirmed':
            return '#e5ac00';
        case 'Confirmed':
            return '#A5C100';
        case 'Ready':
            return '#0064C8';
        case 'On-route':
            return '#00A6DD';
        case 'Completed':
            return '#009100';
        case 'Cancelled':
            return '#BC362F';
        default:
            return '#e5ac00';
    }
};
export const OrderStatusWrapper = styled.div `
  padding: 16px;
  display: grid;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(202px, 1fr));
  grid-gap: 15px;
  padding: 17px 0;
`;
export const OrderStatusItem = styled.div `
  padding: 8px 16px 8px 16px;
  background: ${({ type }) => getOrderItemBg(type)};
  width: 100%;
  height: ${({ height }) => height ? height : "40px"};
  border-radius: 4px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;
export const OrderQuantity = styled.div `
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(12, 32, 42, 0.2);
  div {
    position: relative;
    display: inline-block;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
export const ChangeStatusModalBoard = ({ changeStatusActive, setChangeStatusActive, onChangeStatusOrder }) => {
    const handleSelectStatus = (status) => {
        onChangeStatusOrder(status);
    };
    return (React.createElement(Modal, { active: changeStatusActive, width: 542, close: () => setChangeStatusActive(false), wrapperStyle: {
            fontFamily: 'Inter'
        } },
        React.createElement(ModalTitle, { className: "round-top text-center" },
            React.createElement("h3", null, "Change Order Status")),
        React.createElement(ModalContent, { style: { minHeight: '260px' } },
            React.createElement(OrderStatusWrapper, null, MOCK_ORDER_STATUS_DATA.map(item => (React.createElement(OrderStatusItem, { key: item.id, type: item.text, onClick: () => handleSelectStatus(item.type) },
                React.createElement("div", null, item.text))))),
            React.createElement("div", null,
                React.createElement(Button, { type: "button", full: true, className: "m-r-2", onClick: () => setChangeStatusActive(false) }, "Cancel")))));
};
//# sourceMappingURL=index.js.map